import React from 'react';
import ReactDOM from 'react-dom';
import SqlQueryComponent from './screens/SqlQueryComponent';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <SqlQueryComponent />
  </React.StrictMode>,
  document.getElementById('root')
);
